import { Link, useNavigate } from 'react-router-dom';
import { useState } from "react";
import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import config from '../config/config';
import * as z from "zod";
import Logo1 from '../../src/assets/images/Iq Logo.png';


const formSchema = z.object({
  // Identifier can be email or phone string
  identifier: z.string().min(1, { message: "Email or Phone is required." }),
  password: z.string().min(1, { message: "Password is required." }),
});

export function LoginForm() {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  const form = useForm({
    resolver: zodResolver(formSchema),
    defaultValues: { identifier: "", password: "" },
  });

  const onSubmit = async (data) => {
    try {
      setIsLoading(true);
      setError(null);
      console.log("Attempting login with:", data.identifier);
      // Database constraint "email NOT NULL" ko satisfy karne ke liye 
      // hum identifier ko 'email' key ke naam se bhej rahe hain.
      const loginData = {
        email: data.identifier,
        password: data.password
      };

      const response = await fetch(`${config.baseUrl}/api/auth/login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(loginData)
      });

      const result = await response.json();
      console.log("Server Response:", result);
      if (response.ok) {
        localStorage.setItem('token', result.token);
        localStorage.setItem('role', result.user.role);
        localStorage.setItem('userId', result.user.id);
        localStorage.setItem('userEmail', result.user.email);

        switch (result.user.role) {
          case 'superadmin':
            navigate('/super-admin');
            break;
          case 'admin':
            navigate('/admin');
            break;
          case 'eidday':
            navigate('/eidday');
            break;
          case 'moderator':
            navigate('/moderator-dashboard');
            break;
          default:
            navigate('/registration-options', {
              state: {
                userId: result.user.id,
                userEmail: result.user.email
              }
            });
        }
      } else {
        setError(result.error || 'Login failed');
      }
    } catch (error) {
      setError('An error occurred during login');
    } finally {
      setIsLoading(false);
    }
  };

  return (

    <div className="min-h-screen w-full flex items-center justify-center lg:bg-zinc-100 dark:bg-zinc-900">

      <div className="max-w-md w-full mx-auto space-y-8 bg-white p-10 rounded-3xl shadow-xl border border-slate-200">{/* Header */}
        <div className="text-center">
          {/* Logo Container - Bara aur Gool (Circle) */}
          <div className="mx-auto h-38 w-68 items-center justify-center  shadow-md shadow-blue-100 border-4 border-white bg-sky-700 overflow-hidden ">
            <img src={Logo1} alt="header logo" className="h-full w-full object-cover" />
          </div>
        </div>

        {/* Tabs */}
        <div className="flex p-1.5 bg-slate-200 rounded-xl border border-slate-200">
          <button className="flex-1 py-2.5 text-sm font-bold rounded-xl bg-white text-blue-600 shadow-sm border-none">
            Login
          </button>
          <Link to="/register" className="flex-1 py-2.5 text-sm font-semibold text-slate-500 hover:text-blue-600 text-center transition-all">
            Register
          </Link>
        </div>

        <form onSubmit={form.handleSubmit(onSubmit)} className="mt-8 space-y-5">
          {error && (
            <div className="p-3 bg-red-50 border-l-4 border-red-500 text-red-700 text-xs font-bold rounded shadow-sm">
              {error}
            </div>
          )}

          <div className="space-y-2">
            {/* Identifier Field */}
            <div>
              <label className="block text-xs font-bold text-slate-600 uppercase mb-2 ml-1">Email or Phone</label>
              <input
                {...form.register("identifier")}
                type="text"
                className="w-full px-4 py-2 text-sm sm:text-base border rounded-md bg-slate-50 focus:ring-2 focus:ring-blue-400"
                placeholder="Enter email or phone"
              />
              {form.formState.errors.identifier && (
                <p className="mt-1.5 text-[11px] text-red-500 font-bold ml-2">{form.formState.errors.identifier.message}</p>
              )}
            </div>

            {/* Password Field */}
            <div>
              <div className="flex justify-between mb-2 ml-1">
                <label className="block text-xs font-bold text-slate-600 uppercase">Password</label>
              </div>
              <input
                {...form.register("password")}
                type="password"
                className={`block w-full px-4 py-2 border rounded-md bg-slate-50 text-slate-900 placeholder-slate-400 focus:outline-none focus:ring-4 focus:ring-blue-100 focus:border-blue-500 sm:text-sm transition-all ${form.formState.errors.password ? 'border-red-300' : 'border-slate-200'
                  }`}
                placeholder="••••••••"
              />
              {form.formState.errors.password && (
                <p className="mt-1.5 text-[11px] text-red-500 font-bold ml-2">{form.formState.errors.password.message}</p>
              )}
            </div>
          </div>

          <button
            type="submit"
            disabled={isLoading}
            className="w-full py-2.5 text-sm sm:text-base font-bold rounded-md text-white bg-sky-700 hover:bg-blue-900"          >
            {isLoading ? "Authenticating..." : "SIGN IN TO SYSTEM"}
          </button>
        </form>
      </div>
    </div>
  );
}